import SsmsBarChart from './SsmsBarChart';
export default SsmsBarChart;



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/modern_components/SsmsBarChart/index.js